import {
    Box,
    Tooltip,
    TooltipProps,
    tooltipClasses,
    styled,
    Button
  } from '@mui/material';
  import { useNavigate } from 'react-router-dom';
  
  const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.colors.alpha.trueWhite[100],
      color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
      boxShadow: theme.shadows[24],
      fontWeight: 'bold',
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.colors.alpha.trueWhite[100]
    }
  }));
  
  function SidebarFooter() {
    const navigate = useNavigate();
    
    function logout() {
        localStorage.clear();
        navigate("/");
      }
  
    return (
      <Box
        sx={{
          height: 60 ,
          mx: 2
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Button
            onClick={logout}
            variant="contained"
            color="warning"
            size="small"
            fullWidth
        >
            Log out
        </Button>
      </Box>
    );
  }
  
  export default SidebarFooter;
  